<template>
    <div class="max-w-lg mx-auto py-16 px-4 text-center">
        <div class="mb-6">
            <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
            <h1 class="text-2xl font-bold text-gray-900 mb-2">Checkout cancelado</h1>
            <p class="text-gray-500 text-sm">Não foi concluída a assinatura. Você pode tentar novamente quando quiser.</p>
        </div>
        <div class="flex gap-3 justify-center">
            <router-link :to="{ name: 'subscription' }" class="btn btn-primary text-white">Tentar novamente</router-link>
            <router-link :to="{ name: 'home' }" class="btn btn-ghost">Voltar ao início</router-link>
        </div>
    </div>
</template>

<script>
export default {};
</script>
